var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wxl-notify-view",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',{staticClass:"text",style:(_vm.getstyle())},[_vm._v(_vm._s(_vm.text)+" "),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }